export function recursiveClassToggler(element, className, force = false) {
  if (!element) {
    console.warn('Element not found for recursive class toggler:', element);
    return;
  }
  element.classList.toggle(className, force);
  const elements = element.querySelectorAll(`.${className}`);
  elements.forEach(el => {
    el.classList.toggle(className, force);
  });
}